import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=1fbb8bea&scoped=true"
import script from "./LogoUpload.vue?vue&type=script&lang=ts"
export * from "./LogoUpload.vue?vue&type=script&lang=ts"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&id=1fbb8bea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb8bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbb8bea')) {
      api.createRecord('1fbb8bea', component.options)
    } else {
      api.reload('1fbb8bea', component.options)
    }
    module.hot.accept("./LogoUpload.vue?vue&type=template&id=1fbb8bea&scoped=true", function () {
      api.rerender('1fbb8bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/init-modal/LogoUpload.vue"
export default component.exports